"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactCopyToClipboard = require("react-copy-to-clipboard");

var _commonShareUrl = _interopRequireDefault(require("./common-share-url.css"));

var _commonShareDialog = require("./common-share-dialog.utils");

var CommonShareURL = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(CommonShareURL, _React$PureComponent);

  function CommonShareURL(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.state = {
      copied: false,
      url: props.url
    };
    _this.inputRef = /*#__PURE__*/_react["default"].createRef();
    _this.selectInputValue = _this.selectInputValue.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = CommonShareURL.prototype;

  _proto.selectInputValue = function selectInputValue() {
    var url = this.state.url;
    this.inputRef.current.setSelectionRange(0, url.length);
    this.setState({
      copied: false
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$state = this.state,
        copied = _this$state.copied,
        url = _this$state.url;
    var _this$props = this.props,
        className = _this$props.className,
        copiedLabel = _this$props.copiedLabel,
        copyLabel = _this$props.copyLabel,
        theme = _this$props.theme;
    var label = copied ? copiedLabel : copyLabel;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(_commonShareUrl["default"].shareURL, className)
    }, /*#__PURE__*/_react["default"].createElement("input", {
      ref: this.inputRef,
      onClick: this.selectInputValue,
      onChange: _commonShareDialog.noop,
      className: _commonShareUrl["default"].input,
      value: url
    }), /*#__PURE__*/_react["default"].createElement(_reactCopyToClipboard.CopyToClipboard, {
      text: url,
      onCopy: function onCopy() {
        _this2.setState({
          copied: true
        });
      }
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: theme.critical
    }, label)));
  };

  return CommonShareURL;
}(_react["default"].PureComponent);

exports["default"] = CommonShareURL;
CommonShareURL.displayName = 'CommonShareURL';
CommonShareURL.defaultProps = {
  copiedLabel: 'copied',
  copyLabel: 'copy',
  url: (0, _commonShareDialog.getLocation)()
};